export function setLanguage(locale: string): boolean {
  const currentLang = localStorage.getItem('lang')
  if (currentLang !== locale) {
    localStorage.setItem('lang', locale)
    return true // Indicate that a language change has occurred
  }
  return false // No language change
}

export function getLanguage() {
  return localStorage.getItem('lang')
}

export function getUrlLang() {
  return localStorage.getItem('lang') === 'en' ? '' : localStorage.getItem('lang') || ''
}
